<template>
    <div>
      <div style="display: block;margin-top: 90px" >
        <img src="../assets/images/about3.jpg"  width="100%" />
      </div>
      <section class="about-us">
        <el-row type="flex" align="middle">
          <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
            <div class="container">
              <div class="heading">
                <p>ABOUT US</p>
                <h2 style="margin: 0px"><span>BioEnergy®</span> 介 绍 </h2>
                <div><img src="../assets/images/decor.png" /></div>
              </div>
              <div class="content">
                <p>苏州西姆提纳米科技有限公司是一家中墨合资公司，成立于2018年1月。Bioenergy®是Bio Century的创新品牌，成立于1994年在墨西哥蒙特雷市，生物能源中心—健康实验室于1998年开始运营，2010年在美国达拉斯建造了新的健康中心。2018年在加拿大渥太华成立了健康中心。</p>
                <p>Bioenergy®29年来,一直专注于人类健康产品的研发，帮助人类拥有更好的生活质量。其旗舰产品：生物能源水(Balance Water)。利用与不同的草药成分混合，会增强其特性甚至产生新的特性，彻底改善人体循环系统，增强人体免疫功能，保护我们的身体。</p>
                <p>Bioenergy®不是替代医学，因为它不提供药物，它是一种综合治疗，它的主要功能是改善循环系统的功能，我们的技术、产品是高质量、高标准的。Bioenergy®的创新技术加上各种中草药的天然提取物，给你健康，幸福的高质量的生活品质！</p>
                <!--
                <p>Bioenergy®生化学家<strong>里卡多·萨拉查</strong>毕业于墨西哥蒙特雷技术学院，美国德州农工大学营养与生物化学硕士、生物化学博士学位。持有多项生物医学发明专利，曾在墨西哥第一届结合医学大会上发表主题演讲。</p>
                -->
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <img src="../assets/images/about-us.png" height=300em/>
          </el-col>
        </el-row>
      </section>
      <section class="person">
        <div class="person-bg">
          <el-row type="flex" justify="start" align="middle" >
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" >
              <img src="../assets/images/p1.jpg" style="padding-top: 45px" />
            </el-col>
            <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
              <div style="text-align:left; padding-left:2.5em;display:block;alignment:center; color:wheat;"><span>PhD. Ricardo Salazar</span></div>
              <h2 style="text-align:left;color:cornsilk;margin-top: -1px"><span style="font-size: 1.2em" class="iconfont iconhangye"></span>
                 里卡多·萨拉查博士</h2>

              <p style="text-align:left; color: cornsilk">苏州西姆提纳米科技有限公司首席技术顾问，生物化学家。</p>
              <p style="text-align:left;color: cornsilk">毕业于蒙特雷大学(Tecnologico de Estudios Superiores de Monterrey)工程学专业</p>
              <p style="text-align:left;color: cornsilk">德州农工大学(Texas A&M)获得理学硕士学位</p>
              <p style="text-align:left;color: cornsilk">坎贝尔大学(Cambell University)获得生物化学博士学位</p>
              <p style="text-align:left;color: cornsilk">世界独创的清理大师技术和Bioenergy®品牌的创造者，人体循环系统的解毒和清洁以及各种类型水处理方面的专家,基于量子物理、化学和生物化学，利用纳米技术开发了系列产品。</p>

            </el-col>
          </el-row>

        </div>
      </section>
      <section class="vision">
        <div class="content value">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div class="value-img-span">
                <span class="value-span-h4">企业任务</span>
                <span class="value-span-p">OUR MISSION</span>

                <span class="span-p">
                为人类健康和福祉提供优质的互补和综合的方案
                <br />我们承诺每天都要提供更好的产品和服务
              </span>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div class="value-img"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div class="value-img-span img-span-a">
                <span class="value-span-h4">企业愿景</span>
                <span class="value-span-p">OUR VISON</span>
                <span class="span-p">
                成为领先的竞争品牌，让技术创新得到全面认可
                <br />在世界每个家庭留下印记
              </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section class="">

      </section>
    </div>
</template>

<script>
export default {
  name: 'brand'
}
</script>

<style scoped>
  .about-us{
    margin-top: 20px;
  }
  .container{
    text-align: center;
  }
  .heading{
  //若非响应式布局，则没有问题
  //padding: 5px 0px 0px 170px;
    padding: 5px 0px 0px 8em;
    margin: 0px;
    text-align:left ;
  }
  .heading p{
    padding: 0px;
    margin: 0px;
    color:#707070;
    font-size: 14px;
    letter-spacing: 2px;
  }
  .heading h2 span {
    color: #77b122;
    letter-spacing: 2px;
  }
  .content{
    padding: 5px 0px 0px 8em;
    margin: 0px;
    text-align:left ;
    //font-size: 1em;
  }
  .person-bg{
    background: url('../assets/images/departments.jpg');
    width: 100%;
    height: 500px;
    display: block
  }
  .value {
    padding-top: 50px;
    padding-bottom: 50px
  }
  .value-img {
    width: 300px;
    height: 300px;
    background-image: url("../assets/images/value.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: auto;

  }
  .value-img-span {
    padding-top: 75px;
    text-align: right;
    padding-right: 50px;
    }
  .value-span-h4 {
    width: 100%;
    display: block;
    font-size: 30px;
  }
  .value-span-p {
    width: 100%;
    display: block;
    color: #383838;
    border-bottom: 1px #9a9a9a solid;
    padding: 5px;
  }
  .span-p {
    display: block;
    padding: 10px 0;
    color: #707070;
    line-height: 25px;
  }
  .img-span-a {
    text-align: left;
    padding-left: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/brand.vue